import { motion } from "framer-motion";
import { HeartHandshake } from "lucide-react";
import { FOUNDERS, ORIGIN_STORY, SHORT_BIO, SIGNATURE_QUOTE } from "@/content";

export default function About() {
  return (
    <section id="about" data-testid="about-us-section" className="bg-[#FBF9F1] text-[#232D27] scroll-mt-20">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <p className="overline-gold mb-4">About Us</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1B3B2B] leading-tight">
            Two LA entrepreneurs, 30+ years of sisterhood,{" "}
            <span className="italic text-[#9E7D1E]">one shared purpose.</span>
          </h2>
          <p data-testid="about-short-bio" className="mt-6 text-base sm:text-lg text-[#3A4D41] leading-relaxed">
            {SHORT_BIO}
          </p>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {FOUNDERS.map((f, i) => (
            <motion.article
              key={f.id}
              data-testid={`founders-${f.id}-bio-card`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              className="card-cream p-8 sm:p-10"
            >
              <p className="font-script text-3xl text-[#B8860B]">{f.name.split(" ")[0]}</p>
              <h3 className="font-serif text-2xl text-[#1B3B2B] mt-1">{f.name}</h3>
              <p className="text-[11px] uppercase tracking-[0.2em] text-[#8A9A86] mt-2">{f.role}</p>
              <p className="mt-5 text-[15px] leading-relaxed text-[#3A4D41]">{f.bio}</p>
            </motion.article>
          ))}
        </div>

        <motion.div
          data-testid="origin-story-box"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="mt-6 rounded-3xl bg-[#1B3B2B] text-[#FBF9F1] p-8 sm:p-12 relative overflow-hidden"
        >
          <div className="absolute -top-10 -right-10 w-48 h-48 rounded-full border border-[#D4AF37]/20" />
          <div className="absolute -top-4 -right-4 w-32 h-32 rounded-full border border-[#D4AF37]/15" />
          <div className="flex items-center gap-3 mb-5">
            <HeartHandshake size={20} className="text-[#D4AF37]" />
            <p className="overline-gold">The Origin Story</p>
          </div>
          <h3 className="font-serif text-2xl sm:text-3xl leading-snug max-w-2xl">
            Turning shared loss into sacred healing.
          </h3>
          <p className="mt-5 text-[15px] sm:text-base leading-relaxed text-[#D1DDD5] max-w-3xl">
            {ORIGIN_STORY}
          </p>
          <p data-testid="signature-quote" className="mt-8 font-script text-3xl sm:text-4xl text-[#D4AF37]">
            “{SIGNATURE_QUOTE}”
          </p>
        </motion.div>
      </div>
    </section>
  );
}
